// ACESSO-01 (L9a): o que as telas de Papéis tiram do catálogo de acesso (`GET acesso/catalogo`, store `acesso`).
//
// - A escolha de um módulo é um grupo: o da Powerbizz pela chave, o da conta pelo id, como a API dos papéis os lê.
// - "Sem acesso" é o grupo vazio da Powerbizz, o primeiro de cada módulo. O módulo sem escolha está nele.
// - Os ajustes de um módulo são a diferença entre o que está marcado e os escopos do grupo: o que sobra soma, o que
//   falta tira. A ordem é a do catálogo.

export const SEM_ACESSO = 'sem_acesso';

export const semAcesso = () => ({ origem: 'powerbizz', chave: SEM_ACESSO });

export const ehSemAcesso = escolha =>
  escolha.origem === 'powerbizz' && escolha.chave === SEM_ACESSO;

// A escolha que aponta para um grupo do catálogo ou da ficha do papel (`{ origem, chave, id }`).
export const escolhaDoGrupo = grupo =>
  grupo.origem === 'conta'
    ? { origem: 'conta', id: grupo.id }
    : { origem: 'powerbizz', chave: grupo.chave };

export const mesmoGrupo = (grupo, escolha) =>
  grupo.origem === escolha.origem &&
  (grupo.origem === 'conta'
    ? grupo.id === escolha.id
    : grupo.chave === escolha.chave);

export const gruposDoModulo = (catalogo, modulo) =>
  (catalogo?.grupos || []).filter(grupo => grupo.modulo === modulo);

export const escoposDoModulo = (catalogo, modulo) =>
  (catalogo?.escopos || []).filter(escopo => escopo.modulo === modulo);

// R6: ninguém dá o que não tem. O escopo que não se concede (o travado e o que fica só no modelo Administrador) e o que
// falta a quem edita (o `pode` do `useAcesso`) não se dão: ficam desabilitados, com a mesma nota.
export const naoSeDa = (escopo, pode) =>
  !escopo.concedivel || !pode(escopo.nome);

export const marcadosComAjustes = (doGrupo, ajustes) => {
  const marcados = new Set(doGrupo);
  ajustes.forEach(({ escopo, sentido }) =>
    sentido === 'soma' ? marcados.add(escopo) : marcados.delete(escopo)
  );
  return marcados;
};

// `escopos` são os do módulo, na ordem do catálogo; `marcados` e `doGrupo`, conjuntos de nomes.
export const ajustesDaDiferenca = (escopos, marcados, doGrupo) =>
  escopos.flatMap(({ nome }) => {
    if (marcados.has(nome) && !doGrupo.has(nome))
      return [{ escopo: nome, sentido: 'soma' }];
    if (!marcados.has(nome) && doGrupo.has(nome))
      return [{ escopo: nome, sentido: 'tira' }];
    return [];
  });
